import { SolAvatar, SolBadge } from "@solstice/sol-react";
import type { FC } from "react";
import type { ManageUserProps } from "types";
import { getFormatedDate, joinTwoStr, noPropagation } from "utils";

export interface StyledUserValueProps {
  user: ManageUserProps;
  valueKey: keyof ManageUserProps | "name";
}

const StyledUserValue: FC<StyledUserValueProps> = ({ user, valueKey }) => {
  return (
    <>
      {(() => {
        switch (valueKey) {
          case "name":
            return (
              <div className="flex space-x-2 items-center">
                <SolAvatar
                  size="32"
                  image={user?.photos?.[0] || ""}
                  name={joinTwoStr(user?.first_name, user?.last_name, " ")}
                />
                <div className="truncate">
                  <div className="text-ellipsis overflow-hidden">
                    {joinTwoStr(user?.first_name, user?.last_name, " ")}
                  </div>
                </div>
              </div>
            );
          case "email":
            return (
              <div className="text-ellipsis overflow-hidden">
                <a
                  href={`mailto:${user?.email}`}
                  className="text-jll-color-surface-info-default"
                  onClick={noPropagation}
                >
                  {user?.email}
                </a>
              </div>
            );
          case "is_active":
            if (user?.is_active) {
              return (
                <SolBadge size="small" variant="filled" state="success">
                  <span>Active</span>
                </SolBadge>
              );
            }
            return (
              <SolBadge size="small" variant="filled" state="error">
                <span>Not active</span>
              </SolBadge>
            );
          case "update_timestamp":
            if (!user?.update_timestamp) {
              return <>-</>;
            }
            return <>{getFormatedDate(user?.update_timestamp)}</>;
          case "create_timestamp":
            if (!user?.create_timestamp) {
              return <>-</>;
            }
            return <>{getFormatedDate(user?.create_timestamp)}</>;
          default:
            if (user.hasOwnProperty(valueKey)) {
              return <>{user[valueKey]}</>;
            }
            return <>-</>;
        }
      })()}
    </>
  );
};

export default StyledUserValue;
